// extracted by mini-css-extract-plugin
export var createSetContainerDesktop = "style-mod--create-set-container-desktop--4466d";
export var createSetMobile = "style-mod--create-set-mobile--19075";